<template>
  <div>
    <swiper
      ref="donSwiper"
      class="donor"
      :options="donOpt"
      @slideChange="setIndex"
    >
      <swiper-slide
        class="donor__slide"
        v-for="slide in slidesDon"
        :key="slide.name"
      >
        <div class="donor__wrap">
            <div class="donor__wrap-left">
                <h1 class="donor__title">
                    {{ slide.name }}
                </h1>
                <div
                    class="swiper-pagination donor__pagination"
                    :class="selectColor"
                ></div>
            </div>

          <div class="donor__pic">
            <svg-icon :name="slide.pathTop" :title="slide.name" />
          </div>
        </div>
        <div class="donor__legs">
          <svg-icon :name="slide.pathBot" :title="slide.name" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="donor__nav">
      <div id="donor-prev" class="swiper-button-prev" slot="button-prev"></div>
      <div id="donor-next" class="swiper-button-next"  slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SvgIcon from '../SvgIcon'
export default {
  name: 'DonorBlock',
  data: () => ({
    slidesDon: [
      {
        name: 'Выберите того кому хотите помочь',
        className: 'first',
        pathTop: 'ds-1',
        pathBot: 'dsb-1'
      },
      {
        name: 'Сделайте простой платеж с карты, либо подпишитесь на проект',
        className: 'second',
        pathTop: 'ds-2',
        pathBot: 'dsb-2'
      },
      {
        name: 'Следите за судьбой животного или проекта. Ведь ваш вклад уже изменил чью-то жизнь',
        className: 'third',
        pathTop: 'ds-3',
        pathBot: 'dsb-3'
      }
    ],
    selectColor: 'first',
    donOpt: {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 800,
      effect: 'fade',
        observer: true,
        observeParents: true,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: false
      },
      navigation: {
        nextEl: '#donor-next',
        prevEl: '#donor-prev'
      }
    }
  }),
  components: { Swiper, SwiperSlide, SvgIcon },
  computed: {
    swiper() {
      return this.$refs.donSwiper.$swiper
    }
  },
    mounted(){
    },
  methods: {
    setIndex() {
      this.slidesDon.forEach((el, idx) => {
        if (idx === this.swiper.activeIndex) {
          this.selectColor = el.className
        }
      })

    }
  }
}
</script>

<style lang="scss">
.donor {
  margin: 10px auto;
  margin-bottom: 0;
  &__wrap {
      position: relative;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 10px;
      max-width: 900px;
      margin: 0 auto;

      &-left{
          max-width: 450px;
          padding-right: 15px;
      }
  }
  &__title {
    font-family: 'Comfortaa', sans-serif;
    font-size: 24px;
    line-height: 32px;
    color: #333333;

  }
  &__pic {
    width: 368px;
    height: 216px;
    background: #ffffff;
    //box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    .svg-icon {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__pagination {
      position: static;
    width: 288px;
    border-radius: 5px;
    height: 3px;
    display: flex;
    .swiper-pagination-bullet {
      width: 33.33%;
      height: 3px;
      display: inline-block;
      background: transparent;
      opacity: 1;
      outline: none;
      border-radius: 5px;
      &-active {
        opacity: 1;
      }
    }
    &.first {
      background: #fef1f1;
      .swiper-pagination-bullet {
        &-active {
          background: #ee7372;
        }
      }
    }
    &.second {
      background: #eaf1fc;
      .swiper-pagination-bullet {
        &-active {
          background: #2e76e4;
        }
      }
    }
    &.third {
      background: #f1eef9;
      .swiper-pagination-bullet {
        &-active {
          background: #6c4dbb;
        }
      }
    }
  }
  &__legs {
    margin-top: 85px;
    .svg-icon {
      max-width: 847px;
      width: 100%;
      min-height: 175px;
        margin: 0 auto;
    }
  }
  &__nav {
    display: flex;
    justify-content: center;
    margin-top: -4px;
    padding-top: 30px;
    .swiper-button-prev,
    .swiper-button-next {
      position: static;
      outline: none;
      background: #fff;
      border-radius: 20px;
      padding: 15px 20px;
      width: auto;
      height: auto;
      margin: 0 5px;
    }
    .swiper-button-prev {
      &::after {
        content: '';
        background: url('/assets/images/arrow-r.svg') no-repeat center;
        background-size: cover;
        width: 15px;
        height: 10px;
        transform: rotate(-180deg);
      }
    }
    .swiper-button-next {
      &::after {
        content: '';
        background: url('/assets/images/arrow-r.svg') no-repeat center;
        background-size: cover;
        width: 15px;
        height: 10px;
      }
    }
  }
}



@media (max-width: 992px){
    .donor__legs .svg-icon{
        min-height: auto;
    }

}

@media (max-width: 768px) {
  .donor {
    &__wrap {
      flex-direction: column;
      justify-content: center;
      align-items: center;

        &-left{
            width: 100%;
            padding-right: 0;
        }
    }
    .swiper-pagination {
      position: static;
      margin: 40px 0;
    }
    &__slide {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 610px !important;
    }
    &__legs {
      height: 215px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-top: 15px;
      .svg-icon {
        max-width: 100%;
        width: 100%;

      }
    }
  }
}
@media (max-width: 500px) {
  .donor {
    &__legs {
      //margin-bottom: -20px;
    }
    &__title {
      text-align: center;
    }
  }
}

@media (max-width: 768px){
    .donor__pagination{
        width: 100%;
    }
    .donor__pagination .swiper-pagination-bullet{
        width: 33.33%;
    }
}

@media (max-width: 600px){
    .donor__wrap{
        width: 100%;
    }
    .donor__pic{
        width: 100%;
    }

    .donor__pic .svg-icon img{
        width: 100%;
    }
}

</style>
